/**
 * True when a catalog/list price should be shown (admin entered a positive amount).
 * Hides unset, null, zero, negative, and non-numeric values so we never show "RM 0" for empty pricing.
 */
export function hasDisplayPrice(price) {
  if (price === null || price === undefined || price === '') return false;
  const n = typeof price === 'number' ? price : Number(price);
  return Number.isFinite(n) && n > 0;
}
